import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

export interface RootProps extends ComponentPropsWithoutRef<"div"> {
  isDragging?: boolean;
}

export const Root = forwardRef<HTMLDivElement, RootProps>(
  ({ children, className, isDragging = false, ...rest }, ref) => (
    <div
      ref={ref}
      className={classNames(
        "group/collapsible-section flex w-full flex-col",
        {
          "pointer-events-none opacity-50": isDragging,
        },
        className,
      )}
      {...rest}
      tabIndex={-1}
    >
      {children}
    </div>
  ),
);

Root.displayName = "CollapsibleSection";
